import { EventActionType } from './event-action-type';
import { castArray } from 'lodash';

export interface LoadEventErrorAction {
  errors: Error[];
  eventKey: string;
  type: EventActionType.LoadEventError;
}

export const loadEventError = (
  eventKey: string,
  errors: Error | readonly Error[],
): LoadEventErrorAction => ({
  errors: castArray(errors),
  eventKey,
  type: EventActionType.LoadEventError,
});
